import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shortid from 'shortid';


class FormField extends React.PureComponent {
  static defaultProps = {
    disabled: false,
    nonewrow: false,
    row: false,
    setValue: () => { },
    value: '',
  };

  static propTypes = {
    description: PropTypes.string,
    disabled: PropTypes.bool,
    nonewrow: PropTypes.bool,
    form: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    row: PropTypes.bool,
    setValue: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.any,
    title: PropTypes.string,
    boldTotle: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.id = shortid.generate();
  }

  generateOptions = (option) => {
    let title;
    let value;

    if (typeof option === 'object') {
      const optionTitle = this.props.form.optionTitle;
      const optionValue = this.props.form.optionValue;

      if (optionTitle) {
        title = option[optionTitle];
      } else {
        title = option.title;
      }

      if (optionValue) {
        value = option[optionValue];
      } else {
        value = option.value;
      }

    } else {
      title = option;
      value = option;
    }

    return (<option key={title} value={value} >{title}</option>);
  }

  render() {
    let input;

    switch (this.props.form.type) {
      case 'textinput':
        let className = 'textinput';

        if (this.props.className) {
          className = this.props.className;
        }

        input = <input type="text" id={this.id} className={className}
          disabled={this.props.form.disabled} length={this.props.form.length} maxLength={this.props.form.maxLength}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} onBlur={this.props.onBlur}
          title={this.props.title}
          onKeyDown={this.props.onKeyDown} />;

        break;
      case 'date':
        input = <input type="date" id={this.id} className='textinput'
          disabled={this.props.form.disabled} length={this.props.form.length} maxLength={this.props.form.maxLength}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} onBlur={this.props.onBlur}
          onKeyDown={this.props.onKeyDown} />;

        break;
      case 'password':
        input = <input type="password" id={this.id} className='textinput'
          disabled={this.props.form.disabled} length={this.props.form.length} maxLength={this.props.form.maxLength}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} onBlur={this.props.onBlur} />;

        break;
      case 'file':
        input = <input type="file" id={this.id} className='textinput'
          disabled={this.props.form.disabled} multiple={this.props.form.multiple}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} />;

        break;
      case 'textarea':
        let className2 = 'textinput';

        if (this.props.className) {
          className2 = this.props.className;
        }

        input = <textarea id={this.id} className={className2}
          disabled={this.props.form.disabled} rows={this.props.form.rows} cols={this.props.form.cols} maxLength={this.props.form.maxLength}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} />;

        break;
      case 'textarea-100-percent':
        input = <textarea id={this.id} className='textinput'
          style={{ width: '100%' }}
          disabled={this.props.form.disabled} rows={this.props.form.rows} cols={this.props.form.cols} maxLength={this.props.form.maxLength}
          name={this.props.name} value={this.props.value} onChange={this.props.onChange} />;

        break;
      case 'checkbox':
        input = <input type="checkbox" id={this.id} className={classNames({ 'is-invalid': this.props.errors })} disabled={this.props.form.disabled} name={this.props.name} checked={this.props.value} onChange={this.props.onChange} />;
        break;
      case 'checkbox-left':
        input = <input type="checkbox" id={this.id} className={classNames({ 'is-invalid': this.props.errors })} disabled={this.props.form.disabled} name={this.props.name} checked={this.props.value} onChange={this.props.onChange} />;
        break;
      case 'checkbox-with-id':
        input = <input type="checkbox" id={this.props.id} className={classNames({ 'is-invalid': this.props.errors })} disabled={this.props.form.disabled} name={this.props.name} checked={this.props.value} onChange={this.props.onChange} />;
        break;
      case 'select':
        if (this.props.form.noEmptyOption)
          input = <div className="selectContainer"><select ref={this.input} id={this.id} className={classNames({ 'is-invalid': this.props.errors })} disabled={this.props.form.disabled} name={this.props.name} value={this.props.value} onChange={this.props.onChange}>{this.props.form.noBlank !== true}{this.props.form.options.map(this.generateOptions)}</select></div>;
        else
          input = <div className="selectContainer"><select ref={this.input} id={this.id} className={classNames({ 'is-invalid': this.props.errors })} disabled={this.props.form.disabled} name={this.props.name} value={this.props.value} onChange={this.props.onChange}>{this.props.form.noBlank !== true && <option value="" />}{this.props.form.options.map(this.generateOptions)}</select></div>;

        break;
      default:
        input = <input ref={this.input} id={this.id} disabled={(this.props.disabled) ? 'disabled' : ''} className={classNames('form-control', this.props.type, { 'is-invalid': this.props.errors })} {...this.props.form} name={this.props.name} value={this.props.value} onChange={this.props.onChange} />;
    }

    let displayTitle = '';

    if (this.props.displayTitle) {
      displayTitle = this.props.displayTitle;
    }

    if (this.props.form.nonewrow && this.props.form.nonewcol) {
      return (
        <React.Fragment>
          {this.props.form.title}
          &nbsp;&nbsp;
          {input}{displayTitle}
        </React.Fragment>
      )
    }

    if (this.props.form.nonewrow) {
      return (
        <React.Fragment>
          <td className={this.props.form.titleClass}>
            {this.props.form.title}
            &nbsp;&nbsp;
            {input}{displayTitle}
          </td>
        </React.Fragment>
      )
    }

    if (this.props.form.type === 'checkbox-left') {
      return (
        <tr>
          <td className={this.props.form.valueClass}>
            {input}{this.props.form.title}
          </td>
        </tr>
      )
    }

    return (
      <tr>
        <td className={this.props.form.titleClass}>
          {this.props.form.title}
        </td>
        <td className={this.props.form.valueClass}>
          {input}{displayTitle}
        </td>
      </tr>
    )
  }
}

export default FormField;
